import { render, staticRenderFns } from "./TaxInfo.vue?vue&type=template&id=12c721aa&scoped=true&"
import script from "./TaxInfo.vue?vue&type=script&lang=js&"
export * from "./TaxInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaxInfo.vue?vue&type=style&index=0&id=12c721aa&prod&lang=css&"
import style1 from "./TaxInfo.vue?vue&type=style&index=1&id=12c721aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c721aa",
  null
  
)

export default component.exports